import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGenerateTransactionEventsRequestSchema,
  TGenerateTransactionEventsResponseSchema,
} from "./generateTransactionEvents.schema";

export const generateTransactionEvents = (axios: IAxiosInstance) => {
  return async (body: TGenerateTransactionEventsRequestSchema) => {
    const { odo_user_id, ...rest } = body;

    const response = await axios.noRetry.post<
      IApiResponse<TGenerateTransactionEventsResponseSchema>
    >(`/companies/${odo_user_id}/transactions/events`, rest);

    return response.data;
  };
};
